"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const react_uid_1 = require("react-uid");
const TextFieldWrapper = styled_components_1.default.div `
  position: relative;
  width: 100%;
  margin-top: 25px;

  textarea {
    min-height: 120px;
  }

  .input-field {
    margin-top: 10px;
  }
`;
const FieldValidationError = styled_components_1.default.div `
  color: red;
  font-style: italic;
  margin-top: 5px;
  div::first-letter {
    text-transform: uppercase;
  }
`;
const InputLabel = styled_components_1.default.label `
  position: absolute;
  left: 10px;
  top: 0px;
  display: flex;
  gap: 2px;
  max-width: calc(100% - 15px);
  padding: 0 5px;
  font-size: 14px;
  color: #999;
  background-color: #fff;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
const DEFAULT_MAX_LENGTH = 524288;
const MaterialTextField = (0, react_1.forwardRef)(({ fieldData, onChange, textarea = false, helperText = '', maxLength }, ref) => {
    const inputRef = (0, react_1.useRef)(null);
    (0, react_1.useImperativeHandle)(ref, () => ({
        focus: () => {
            var _a, _b;
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
    }));
    const renderHelperText = () => {
        if (fieldData.semanticType === 'room_number' && fieldData.type !== 'billing_id') {
            return react_1.default.createElement(react_1.default.Fragment, null, i18n_js_1.default.t('booking_room_number_hint'));
        }
        if (fieldData.type === 'confirmation_email') {
            return react_1.default.createElement(react_1.default.Fragment, null, i18n_js_1.default.t('booking_confirmation_email_hint'));
        }
        return react_1.default.createElement(react_1.default.Fragment, null, helperText);
    };
    return (react_1.default.createElement(TextFieldWrapper, null,
        react_1.default.createElement(material_1.Box, { className: fieldData.errors && fieldData.errors.length > 0 ? 'field-error' : '' },
            react_1.default.createElement(material_1.TextField, { id: "filled-basic", className: "input-field", variant: "outlined", fullWidth: true, error: fieldData.errors && fieldData.errors.length > 0, multiline: textarea, onChange: onChange(fieldData), required: fieldData.mandatory, value: fieldData.value ? fieldData.value : '', disabled: fieldData.disabled || false, placeholder: fieldData.placeholder ? fieldData.placeholder : '', type: fieldData.type === 'integer' ? 'number' : 'text', inputProps: {
                    'data-testid': 'input-field',
                    maxLength: maxLength || DEFAULT_MAX_LENGTH,
                }, helperText: renderHelperText(), inputRef: inputRef }),
            react_1.default.createElement(InputLabel, null,
                react_1.default.createElement("span", null, fieldData.label),
                fieldData.mandatory ? '*' : ''),
            fieldData.errors && fieldData.errors.length > 0 && (react_1.default.createElement(FieldValidationError, null, fieldData.errors.map(error => (react_1.default.createElement("em", { key: (0, react_uid_1.uid)(error) }, error))))))));
});
exports.default = MaterialTextField;
